/**
 * This enumeration represents all possible ways of representing a group of objects in the UI
 */

export enum ViewMode {
  ListElement = 'listElement',
  GridElement = 'gridElement',
  DetailedListElement = 'detailedListElement',
  StandalonePage = 'standalonePage',
}
